import { CSSProperties, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

// components
import { Menu, Sidebar, Icon } from "semantic-ui-react";
import Calendar from "react-calendar";
import "./calendar.css";

// assets
import DashboardLogo from "assets/icons/dashboard_logo.png";

// types
import { Page } from "containers/app/types";
import { useRecoilValue } from "recoil";
import { SchoolIDState } from "global-states";

const MenuItemStyle: CSSProperties = {
  textTransform: "capitalize",
};

const SidebarMenu = ({
  sidebarOpen,
  onSidebarToggle,
  pages,
}: {
  sidebarOpen: boolean;
  onSidebarToggle: () => void;
  pages: Page[];
}) => {
  const location = useLocation();
  const history = useHistory();
  const schoolID = useRecoilValue(SchoolIDState);
  function onPageNavigate(path: string) {
    history.push(path.replaceAll(":uid", schoolID));
  }

  const displayPages = useMemo(() => {
    if (location.pathname.includes("/integration")) {
      return pages.filter((page) => page.path.includes("/integration"));
    } else {
      return pages.filter((page) => !page.path.includes("/integration"));
    }
  }, [location.pathname, pages]);

  return (
    <Sidebar as={Menu} vertical animation="push" visible={sidebarOpen}>
      <Menu.Item onClick={onSidebarToggle} style={{ height: "3rem" }}>
        <img
          src={DashboardLogo}
          alt="Dayta_Logo"
          style={{ height: 16, width: 70 }}
        />
        <Icon name="chevron left" />
      </Menu.Item>
      <Menu.Item>Welcome back!</Menu.Item>
      <Calendar />
      {displayPages.map((page) => (
        <Menu.Item
          key={page.path}
          style={MenuItemStyle}
          onClick={() => onPageNavigate(page.path)}
        >
          {page.name}
        </Menu.Item>
      ))}
    </Sidebar>
  );
};

export default SidebarMenu;
